var loadScript = function(url, callback){

  var script = document.createElement("script")
  script.type = "text/javascript";

  if (script.readyState){  //IE
    script.onreadystatechange = function(){
      if (script.readyState == "loaded" ||
          script.readyState == "complete"){
        script.onreadystatechange = null;
        callback();
      }
    };
  } else {  //Others
    script.onload = function(){
      callback();
    };
  }

  script.src = url;
  document.getElementsByTagName("head")[0].appendChild(script);

};

var myAppJavaScript = function($){
  
  /* youtube player */
  var div, n,
      v = document.getElementsByClassName("youtube-player");
  for (n = 0; n < v.length; n++) {
    div = document.createElement("div");
    div.setAttribute("data-id", v[n].dataset.id);
    div.innerHTML = labnolThumb(v[n].dataset.id);
    div.onclick = labnolIframe;
    v[n].appendChild(div);
  }

  function labnolThumb(id) {
    var thumb = '<img src="//i.ytimg.com/vi/ID/hqdefault.jpg">',
        play = '<div class="play"></div>';
    return thumb.replace("ID", id) + play;
  }

  function labnolIframe() {
    var iframe = document.createElement("iframe");
    var embed = "//www.youtube.com/embed/ID?autoplay=1";
    iframe.setAttribute("src", embed.replace("ID", this.dataset.id));
    iframe.setAttribute("frameborder", "0");
    iframe.setAttribute("allowfullscreen", "1");
    this.parentNode.replaceChild(iframe, this);
  }
  /* end youtube player */

  var canvasToImg = false;

  // on click business nav
  $('.vertical-menu .dropdown_link--vertical').on('click', function(e){
    e.preventDefault();
    return false;
  });

  // Modal script
  // Get the modal
  var modal = document.getElementById('uploadImageModal');

  //Get the button that opens the modal
  var btn = document.getElementById("upload-custom");
  if ( btn ) {
    btn.onclick = function() {
      modal.style.display = "block";
    }
  }

  //Get the <span> element that closes the modal
  var span = document.getElementsByClassName("close")[0];
  if ( span ) {
    span.onclick = function() {
      modal.style.display = "none";
    }
  }

  // When the user clicks anywhere outside of the modal, close it
  window.onclick = function(event) {
    if (event.target == modal) {
      modal.style.display = "none";
    }
  }
  // end Modal script

  $('.build-your-own .preview').hide();
  
  // Build your Own Page nav
  var currentStep = 1;
  $(".build-your-own .nav a, .build-your-own .steps .step, a.preview-canvas, #nav-refresh").hide();
  

  $("#step-1").show();

  $("#nav-next").on('click', function(e){
    e.preventDefault();
    currentStep++;
    $(".steps .step").hide();
    $('.steps #step-' + currentStep).show();
    if ( currentStep != 1 ){
      $("#submit").hide();
      $("#nav-refresh").show();
    }
    if ( currentStep == 2 ){
      $("#nav-next").hide();
      $("#submit").show();
    }
    $("#check-1-step").removeClass('active');
    
    $("#check-2-step").addClass('active');

  });

  $("#nav-back").on('click', function(e){
    e.preventDefault();
    currentStep--;
    $(".steps .step").hide();
    $('.steps #step-' + currentStep).show();
    if ( currentStep == 1 ){
      $("#submit").hide();
      $("#nav-back").hide();
    }
    if ( currentStep != 2 ){
      $("#submit").hide();
      $("#nav-next").show();
    }
    $("#check-2-step").removeClass('active');
    $("#check-1-step").addClass('active');
  });

  $("a.preview-canvas").on('click', function(e){
    
    $(".email-text").show();
    
    e.preventDefault();
    // if ( !canvasToImg ) {
    //   canvasToImage();
    //   canvasToImg = true;
    // }
drawZoomRotate();
    canvasToImage();
  })
  
  // on change second step qty, update form quantity
  //$("input#stepQty").on('change', function(e){
  $("input#stepQty").keyup(function(e){
    e.preventDefault();
    var qty = $(this).val();

   if ($("#custom-meboard").css('visibility') ) {
     //alert('me-board');
    if ( qty >= 21 ) {
      showMaxQtyForm();
      
       $(".newprice").text('Email Us Below');
    }
      else {
      $("input[name=id]").val('29281729478761');
      $("span#newPrice").text( '$5.95' );
      $("span#msrp").hide();

      hideMaxQtyForm();
    } 
     
    if ( (qty >= 4) && (qty <= 10)  ) {
       $(".changevariant").val('29281729511529');
       $(".newprice").text( '$4.95' );
    } 
    if ( (qty >= 11) && (qty <= 20)  ) {
       $(".changevariant").val('29281729544297');
       $(".newprice").text( '$3.95' );
  } 
   } 
    
    else {
    if ( qty >= 50  ) {
      showMaxQtyForm();
      
       $(".newprice").text('Email Us Below');
    }
    else {
      $("input[name=id]").val('29281747796073');
      $("span#newPrice").text( '$19' );
      $("span#msrp").hide();

      hideMaxQtyForm();
    }
if ( (qty >= 2) && (qty <= 5)  ) {
     
  $(".changevariant").val('44082864128218');// 29281747828841
    $(".newprice").text( '$15' );
 
    }
    if ( (qty >= 6) && (qty <= 15)  ) {
     
  $(".changevariant").val('44082865504474');//29281747861609
    $(".newprice").text( '$8' );
 
    }

      if ( (qty >= 16) && (qty <= 24)  ) {
     
  $(".changevariant").val('44082866815194');//29281491583081
    $(".newprice").text( '$7' );
 
    }
          if ( (qty >= 25) && (qty <= 49)  ) {
     
  $(".changevariant").val('44082867241178');//
    $(".newprice").text( '$6' );
 
    } 
      
   }

    $(".build-your-own form input#quantity").val( qty );
  });

/********************** click qty STARTS****************/
/********************** click qty STARTS****************/  
  $("input#stepQty").click(function(e){
    e.preventDefault();
    var qty = $(this).val();

   if ($("#custom-meboard").css('visibility') ) {
     //alert('me-board');
    if ( qty >= 21 ) {
      showMaxQtyForm();
      
       $(".newprice").text('Email Us Below');
    }
      else {
      $("input[name=id]").val('29281729478761');
      $("span#newPrice").text( '$5.95' );
      $("span#msrp").hide();

      hideMaxQtyForm();
    } 
     
    if ( (qty >= 4) && (qty <= 10)  ) {
       $(".changevariant").val('29281729511529');
       $(".newprice").text( '$4.95' );
    } 
    if ( (qty >= 11) && (qty <= 20)  ) {
       $(".changevariant").val('29281729544297');
       $(".newprice").text( '$3.95' );
  } 
   } 
    
     else {
    if ( qty >= 50  ) {
      showMaxQtyForm();
      
       $(".newprice").text('Email Us Below');
    }
    else {
      $("input[name=id]").val('29281747796073');
      $("span#newPrice").text( '$19' );
      $("span#msrp").hide();

      hideMaxQtyForm();
    }
if ( (qty >= 2) && (qty <= 5)  ) {
     
  $(".changevariant").val('44082864128218');// 29281747828841
    $(".newprice").text( '$15' );
 
    }
    if ( (qty >= 6) && (qty <= 15)  ) {
     
  $(".changevariant").val('44082865504474');//29281747861609
    $(".newprice").text( '$8' );
 
    }

      if ( (qty >= 16) && (qty <= 24)  ) {
     
  $(".changevariant").val('44082866815194');//29281491583081
    $(".newprice").text( '$7' );
 
    }
          if ( (qty >= 25) && (qty <= 49)  ) {
     
  $(".changevariant").val('44082867241178');//
    $(".newprice").text( '$6' );
 
    } 
      
   }

    $(".build-your-own form input#quantity").val( qty );
  });
  /* click qty ENDS*/
  
  function hideMaxQtyForm() {
    $('.steps form#myAwesomeForm .nav, .adtocart, #step-2 p:last-child,#nav-refresh, .email-text').show();
    $('.maxQtyContainer').hide();
  }

  function showMaxQtyForm() {
    $('.steps form#myAwesomeForm .nav, .adtocart , #step-2 p:last-child ,#nav-refresh, .email-text').hide();
    $('.maxQtyContainer').show();
  }

  var device_width = $(window).width();
  //alert(device_width);

  var canvas;
  var imgObjPreview = new Image(),
      mobileImgWidth, mobileImgHeight, useWidth, useHeight;
  
  if(parseInt(device_width) > 800){
    // on file upload
    var widthStandard = 480;
    var heightStandard = 365;
    var form_data = new FormData();

    if ( $("#custom-product").length ) {
      canvas = new fabric.Canvas('custom-product');
      canvas.setHeight(365);
      canvas.setWidth(480);
    }

    if( $("#imgfile").length ) { 
      document.getElementById('imgfile').onchange = function handleImage(e) {
        
        var input, file;

        input = document.getElementById('imgfile');
        file = input.files[0];
        fsize = Math.round((file.size / 5000));

        if( fsize > 999 ) {

          alert('Please try a smaller image. Max. file size is 5 MB');
          return;
        }
            $('#custom-product').removeClass('lower-canvas'); 
        $('a.preview-canvas').show();
          $(".uploadbtn").text("Replace Image");
        $('#nav-refresh2').show();
      
         var htmlbtnnfull =  $(".htmlbtnnfull").html();
        $(".newbtnadd").html(htmlbtnnfull);
        $(".htmlbtnnfull").hide();
         $(".changetitle").text("ADJUST IMAGE TO YOUR LIKING");
        $(".changepara").text("Use sliders to adjust image to fit then click preview to see how they look.");
        $(".changetitle-g").hide();
        $(".changepara-g").hide();
       $(".hidelast").hide();
        var reader = new FileReader();
        reader.onload = function (event){
          
          canvas.clear();

          var imgObj = new Image();
          imgObj.src = event.target.result;
          imgObj.onload = function () {
            var image = new fabric.Image(imgObj);

            if((widthStandard/heightStandard)>(imgObj.width/imgObj.height)){
              useWidth= imgObj.width * (heightStandard/imgObj.height);
              useHeight= heightStandard;
            }else{
              useHeight= imgObj.height * (widthStandard/imgObj.width);
              useWidth= widthStandard;

            }

            if( imgObj.naturalWidth < useWidth )
              useWidth = imgObj.naturalWidth;

            if( imgObj.naturalHeight < useHeight )
              useHeight = imgObj.naturalHeight;

            imgObjPreview.width = useWidth;
            imgObjPreview.height = useHeight;

            image.set({
              angle: 0,
              padding: 0,
              cornersize:0,
              height: useHeight,
              width: useWidth,
            });
            canvas.centerObject(image);
            canvas.add(image);
            canvas.renderAll();
            
          }
          $('#custom-product').attr('src', event.target.result);
          imgObjPreview.src = event.target.result;
        }

        reader.readAsDataURL(e.target.files[0]);

        modal.style.display = "none";
        $(".build-your-own .nav a#nav-next").hide();
        
      }
    }


  } else {

    var widthStandard = 293;
    var heightStandard = 230;

    var form_data = new FormData();

    if ( $("#custom-product").length ) {

      canvas = new fabric.Canvas('custom-product');
      canvas.setHeight(230);
      canvas.setWidth(293);
    }

    if( $("#imgfile").length ) {
      document.getElementById('imgfile').onchange = function handleImage(e) {
        
        var input, file;

        input = document.getElementById('imgfile');
        file = input.files[0];
        fsize = Math.round((file.size / 5000));

        if( fsize > 999 ) {

          alert('Please try a smaller image. Max. file size is 5 MB');
          return;
        }
        
        $('a.preview-canvas').show();
         $('#custom-product').removeClass('lower-canvas'); 
        $('a.preview-canvas').show();
          $(".uploadbtn").text("Replace Image");
         var htmlbtnnfull =  $(".htmlbtnnfull").html();
        $(".newbtnadd").html(htmlbtnnfull);
        $(".htmlbtnnfull").hide();
         $(".changetitle").text("ADJUST IMAGE TO YOUR LIKING");
        $(".changepara").text("Use sliders to adjust image to fit then click preview to see how they look.");
       $(".hidelast").hide();
        var reader = new FileReader();
        reader.onload = function (event){
          
          canvas.clear();

          var imgObj = new Image();
          imgObj.src = event.target.result;
          imgObj.onload = function () {
            var image = new fabric.Image(imgObj);

            if((widthStandard/heightStandard)>(imgObj.width/imgObj.height)){
              useWidth= imgObj.width * (heightStandard/imgObj.height);
              useHeight= heightStandard;
            }else{
              useHeight= imgObj.height * (widthStandard/imgObj.width);
              useWidth= widthStandard;

            }

            image.set({
              angle: 0,
              padding: 0,
              cornersize:0,
              height: useHeight,
              width: useWidth,
            });

            imgObjPreview.width = useWidth;
            imgObjPreview.height = useHeight;

            canvas.centerObject(image);
            canvas.add(image);
            canvas.renderAll();
          }
          $('#custom-product').attr('src', event.target.result);
          imgObjPreview.src = event.target.result;
        }

        reader.readAsDataURL(e.target.files[0]);

        modal.style.display = "none";
        $(".build-your-own .nav a#nav-next").show();

        scrollToTop();
      }
    }

  }

  var sliderWidth = 50,
      degrees = 0,
      adjusted = false;

  if ( $( "#slider-zoom" ).length ) {
    $( "#slider-zoom" ).slider({
      value: 50,
      slide: function( event, ui ) {

        adjustImgZoom( ui.value, true );
      }
    });
    
  }

  if ( $("#slider-rotate").length ) {
    $("#slider-rotate").slider({
      value: 50,
//       max: 100,
      slide: function( event, ui ){

        adjustImgRotate( ui.value );
      }
    })
  }

  var sliderZoomVal = $('#slider-zoom').slider("value");

  $('img.zoom-in').on('click', function(e){
    sliderZoomVal++;
    adjustImgZoom( sliderZoomVal, false );
  });

  $('img.zoom-out').on('click', function(e){
    sliderZoomVal--;
    adjustImgZoom( sliderZoomVal, false );
  });

  var sliderRotateVal = $('#slider-rotate').slider("value");

  $('img.rotate-2').on('click', function(e){
    sliderRotateVal++;
    adjustImgRotate( sliderRotateVal );
  })

  $('img.rotate-1').on('click', function(e){
    sliderRotateVal--;
    adjustImgRotate( sliderRotateVal );
  })

  function adjustImgZoom( zoomValue, isSlide ) {

    sliderWidth = zoomValue - 50;

    if ( isSlide ) 
      sliderZoomVal = sliderWidth + 50;

    canvas.clear();

    drawZoomRotate(false);

    $( "#slider-zoom" ).slider("value", zoomValue );

    adjusted = true;
  }

  function adjustImgRotate( rotateValue ) {
    
    console.log( rotateValue );

    if ( !adjusted ) sliderWidth = rotateValue - 50;

    degrees = rotateValue - 50;

    // if ( isSlide )
    //   sliderRotateVal = degrees + 50;

    canvas.clear();
    drawZoomRotate(true);

    $( "#slider-rotate" ).slider("value", rotateValue );

    adjusted = true;
  }

  function drawZoomRotate(translate) {

    var imgWidth = ( (sliderWidth / 100) * imgObjPreview.width) + imgObjPreview.width,
        imgHeight = ( (sliderWidth / 100) * imgObjPreview.height) + imgObjPreview.height;

    var zoomX = canvas.width / 2 - imgWidth / 2,
        zoomY = canvas.height / 2 - imgHeight / 2;

    var ctx = canvas.getContext('2d');
    
    ctx.clearRect(0,0,canvas.width,canvas.height);

    // ctx.save();

    ctx.translate(canvas.width / 2, canvas.height / 2);

    if ( !translate ) degrees = 0;

    // console.log( -degrees );

    ctx.rotate( -degrees*Math.PI/180 );
    ctx.translate(-canvas.width / 2, -canvas.height / 2);
 // jpeg background
     ctx = canvas.getContext("2d");
    var size=800;
  ctx.fillStyle = '#fff';
  ctx.beginPath();
  ctx.fillStyle = '#fff';
  ctx.moveTo(0,-400);
  ctx.lineTo(size,0);
  ctx.lineTo(size,size);
  ctx.lineTo(0,size);
  ctx.lineTo(0,0);
  ctx.stroke();
  ctx.fill();

    ctx.drawImage(
      imgObjPreview,
      zoomX,
      zoomY,
      imgWidth,
      imgHeight
    );

    ctx.restore();
  }
  
  $("#upload-custom").click(function(){ 
    canvas.clear();
  });
  

  $("form#myAwesomeForm").on('submit', async function(e) {
  	e.preventDefault();
    var $submitBtn = $("form#myAwesomeForm #submit");
    $submitBtn.val('Loading ...').prop('disabled', true);

    var variantId = $("input[name='id']").val();
    form_data.set("id", variantId);
    form_data.set("quantity", $("input[name='quantity']").val() );
    // Hidden property: the cart template hides "_"-prefixed properties from
    // the customer and renders quantity as read-only text for lines that
    // have it, since this quantity was picked to earn a specific price tier.
    form_data.set("properties[_locked_qty]", "1");
 /*    form_data.append("properties[Full Name]", $("input[name='properties[Full Name]']").val() );
    form_data.append("properties[email]", $("input[name='properties[email]']").val() );
    form_data.append("properties[message]", $.trim($("textarea").val()) ); */

    var sectionsToBundle = ["variant-added"];
    document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", {
      bubbles: true,
      detail: { sections: sectionsToBundle }
    }));
    form_data.set("sections", sectionsToBundle.join(","));
    form_data.set("sections_url", `${Shopify.routes.root}variants/${variantId}`);

    var thisForm = this;

    try {
      var response = await fetch(`${Shopify.routes.root}cart/add.js`, {
        method: "POST",
        body: form_data,
        headers: { "X-Requested-With": "XMLHttpRequest" }
      });
      var responseJson = await response.json();

      if (response.ok) {
        var cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
        cartContent["sections"] = responseJson["sections"];
        thisForm.dispatchEvent(new CustomEvent("variant:add", {
          bubbles: true,
          detail: {
            items: responseJson.hasOwnProperty("items") ? responseJson["items"] : [responseJson],
            cart: cartContent
          }
        }));
        document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
          bubbles: true,
          detail: { baseEvent: "variant:add", cart: cartContent }
        }));
      } else {
        console.log( "Error " + response.status + " occurred when trying to upload your file.<br \/>" );
        thisForm.dispatchEvent(new CustomEvent("cart:error", {
          bubbles: true,
          detail: { error: responseJson["description"] }
        }));
        document.dispatchEvent(new CustomEvent("cart:refresh"));
      }
    } finally {
      $submitBtn.val('Add to Cart').prop('disabled', false);
    }

    return false;
  });
  
  // on click Preview Custom Upload  
  function canvasToImage(){
    
    var canvas = document.getElementById('custom-product');
    var imageSource = canvas.toDataURL();
    
   // var div = document.createElement('div');
   // div.className = 'crop';
    //div.style.height = '150px';
    //div.style.width = '180px';
   // div.style.overflow = 'hidden';
   // div.style.borderRadius = '50%';
   // div.style.border = '1px solid #000';
   // div.style.backgroundImage = 'url('+imageSource+')';
   // div.style.backgroundPosition = 'center';
   // div.style.backgroundSize = 'cover';
   // div.style.backgroundRepeat = 'no-repeat';
    
    // w.document.write(div.outerHTML);

    // $('.custom-container').hide();
    
//     var orig = document.createElement('div');
//     orig.className = 'crop';
//     orig.style.height = '150px';
//     orig.style.width = '180px';
//     orig.style.overflow = 'hidden';
//     orig.style.borderRadius = '50%';
//     orig.style.border = '1px solid #000';
//     orig.style.backgroundImage = 'url('+ $('#custom-product').attr('src') +')';
//     orig.style.backgroundPosition = 'center';
//     orig.style.backgroundSize = 'cover';
//     orig.style.backgroundRepeat = 'no-repeat';
    
//     $('.original-container').append( orig ).show();
    
 
    
    $('.preview-container').append( div ).show();
    
    $('#nav-next').trigger('click');

    // if ( $(window).width() < 767 ) {
    //   scrollToTop();
    // }
    
    // Original Image
    var origBlob = dataURItoBlob( $("#custom-product").attr('src') );
    form_data.append("properties[Original]", origBlob, 'image.png');

    // Custom Image
    var imgSrc    = canvas.toDataURL("image/png");
    $("#duplicate").attr('src', imgSrc);
    
    var photoKey = document.getElementById('duplicate');
    
    var blob = dataURItoBlob( imgSrc );
    
    form_data.append("properties[Custom]", blob, 'image.png');
var imageget =    $('.imageget').attr('src');
   
    // $('.preview-container').append('<img class="img4" src='+imageget+'>');
    //$('.preview-container').append('<img class="img4" src='+imageget+'>');
   //  $('.preview-container').append('<img class="img4" src='+imageget+'>');
   //  $('.preview-container').append('<img class="img4" src='+imageget+'>');
     $('.iconsimg').show();
     if ($("#custom-meboard").css('visibility') ) {
         $('.previewafter').html('<div class="preview-meboard"><div class="singleme"><img class="meimg" src='+imageget+'></div>'); 
     } else {
    $('.previewafter').html('<div class="preview-containergg"><div class="fissimg"><img class="img4 frrimgg" src='+imageget+'><img class="img4" src='+imageget+'></div><div class="secimg"><img class="img4 secdivimg" src='+imageget+'><img class="img4" src='+imageget+'></div></div><p class="preview-text center">Actual size 1" x .0823" (Size of a nickel)</p>');
   //
     }
  
  
  
  }
  
  function dataURItoBlob(dataURI) {
    // convert base64/URLEncoded data component to raw binary data held in a string
    var byteString;
    if (dataURI.split(',')[0].indexOf('base64') >= 0)
      byteString = atob(dataURI.split(',')[1]);
    else
      byteString = unescape(dataURI.split(',')[1]);

    // separate out the mime component
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

    // write the bytes of the string to a typed array
    var ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ia], {type:mimeString});
  }

  function scrollToTop() {
    $("html, body").animate({ scrollTop: 0 }, "slow");
    return false;
  }
};


if ((typeof jQuery === 'undefined') || (parseFloat(jQuery.fn.jquery) < 1.7)) {
  loadScript('//ajax.googleapis.com/ajax/libs/jquery/1.9.1/jquery.min.js', function(){
    jQuery191 = jQuery.noConflict(true);
    myAppJavaScript(jQuery191);
  });
} else {
  myAppJavaScript(jQuery);
}